import React, { useState, useEffect } from 'react';
import { Box, Grid, Paper, Typography, Button } from '@mui/material';

const GRID_SIZE = 4;
const EMOJIS = ['🎮', '🎲', '🎯', '🎨', '🎭', '🎪', '🎢', '🎡'];

export default function MemoryGame() {
    const [cards, setCards] = useState([]);
    const [flipped, setFlipped] = useState([]);
    const [matched, setMatched] = useState([]);
    const [moves, setMoves] = useState(0);
    const [gameOver, setGameOver] = useState(false);

    useEffect(() => {
        initializeGame();
    }, []);

    const initializeGame = () => {
        // Create pairs of cards
        const cardPairs = EMOJIS.flatMap((emoji, id) => [
            { id, emoji },
            { id, emoji },
        ])
            .sort(() => Math.random() - 0.5)
            .map((card, index) => ({ ...card, index })); // add index after shuffle

        setCards(cardPairs);
        setFlipped([]);
        setMatched([]);
        setMoves(0);
        setGameOver(false);
    };

    const handleCardClick = (index) => {
        // Prevent clicking more than 2 cards at once
        if (flipped.length >= 2) return;
        // Prevent clicking already matched or flipped cards
        if (matched.includes(index) || flipped.includes(index)) return;

        const newFlipped = [...flipped, index];
        setFlipped(newFlipped);

        // Only check for a match when two cards are flipped
        if (newFlipped.length === 2) {
            const [firstCard, secondCard] = newFlipped;

            // Check if the two flipped cards match
            if (cards[firstCard].id === cards[secondCard].id) {
                // Add both matched cards to the matched array
                const newMatched = [...matched, firstCard, secondCard];
                setMatched(newMatched);

                // Keep matched cards visible and clear flipped ones
                setTimeout(() => {
                    setFlipped([]);
                }, 500);

                // Check if all pairs are matched (game complete)
                if (newMatched.length === cards.length) {
                    setGameOver(true);
                }
            } else {
                // If no match, flip both cards back after delay
                setTimeout(() => {
                    setFlipped([]);
                }, 1000);
            }

            // Increment move counter
            setMoves((prev) => prev + 1);
        }

        // // If two cards are flipped, check for match
        // if (flipped.length === 1) {
        //     setMoves(m => m + 1);
        //     const firstIndex = flipped[0];


        //     // Check for match
        //     if (cards[firstIndex].id === cards[index].id) {
        //         setMatched(prev => [...prev, firstIndex, index]);
        //         // Clear flipped only after setting matched
        //         setTimeout(() => {
        //             setFlipped([]);
        //         }, 500);

        //         if (matched.length + 2 === cards.length - 2) {
        //             setGameOver(true);
        //         }
        //     } else {
        //         // No match - keep cards visible for 1 second
        //         setTimeout(() => {
        //             setFlipped([]);
        //         }, 1000);
        //     }
        // }
    };

    return (
        <Box sx={{ p: 2, textAlign: 'center', width: '100%' }}>
            <Typography variant="h5" gutterBottom sx={{ color: '#fff', mb: 3 }}>
                Memory Game
            </Typography>
            <Typography variant="body1" gutterBottom sx={{ color: '#fff', mb: 4 }}>
                Moves: {moves}
            </Typography>
            <Grid
                container
                spacing={2}
                sx={{
                    maxWidth: 400,
                    margin: '0 auto',
                    justifyContent: 'center'
                }}
            >
                {cards.map((card, index) => (
                    <Grid item xs={3} key={index}>
                        <Paper
                            sx={{
                                aspectRatio: '1/1',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: matched.includes(index) ? 'default' : 'pointer',
                                backgroundColor: matched.includes(index) ? '#2d8a82' : '#1b3a57',
                                color: '#fff',
                                transition: 'all 0.3s ease',
                                fontSize: '2rem',
                                minHeight: '80px',
                                '&:hover': {
                                    transform: matched.includes(index) ? 'none' : 'scale(1.05)',
                                    backgroundColor: matched.includes(index) ? '#2d8a82' : '#234567'
                                },
                            }}
                            onClick={() => handleCardClick(index)}
                        >
                            {(flipped.includes(index) || matched.includes(index)) ? card.emoji : '?'}
                        </Paper>
                    </Grid>
                ))}
            </Grid>
            {gameOver && (
                <Box sx={{ mt: 4 }}>
                    <Typography variant="h6" gutterBottom sx={{ color: '#fff' }}>
                        Congratulations! Completed in {moves} moves!
                    </Typography>
                    <Button
                        variant="contained"
                        onClick={initializeGame}
                        sx={{
                            backgroundColor: "#65b3f3ff",
                            mt: 2,
                            '&:hover': {
                                backgroundColor: "#4a9fe9",
                            }
                        }}
                    >
                        Play Again
                    </Button>
                </Box>
            )}
        </Box>
    );
}